import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Router} from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { NoteDTO } from 'src/app/interfaces/note';
import { UserDTO } from 'src/app/interfaces/user';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-change-title',
    imports: [ FormsModule, MatLabel, MatFormField, MatInputModule],
    templateUrl: './change-title.component.html',
    styleUrls: ['./change-title.component.scss'],
})
export class ChangeTitleComponent implements OnInit {

  note: NoteDTO;
  isLoggedIn: boolean;
  user: UserDTO;
  role: string;
  isOk: boolean;
  title: string;

  constructor(private router: Router, private tokenStorageService: TokenStorageService, public dialogRef: MatDialogRef<ChangeTitleComponent>, @Inject(MAT_DIALOG_DATA) data) { 
    this.note = data;
    this.title = this.note.title;
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.role = this.user.role;
      this.isOk = true;
    } else {
      this.isOk = false;
    } 
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
    this.isAuthorized();
  }

  save() {
    this.dialogRef.close({data: this.title});
  }
}
